export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "email_auto": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email auto-généré"])},
        "compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conforme"])},
        "non_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non conforme"])}
      },
      "en": {
        "email_auto": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Auto-generated email"])},
        "compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compliant"])},
        "non_compliant": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non compliant"])}
      }
    }
  })
}
